import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';
import { CarbonIconProps, CheckmarkFilled32 } from '@carbon/icons-react';
import {
  Box,
  BoxProps,
  HeadingProps,
  Text,
  Flex,
  List as ChakraList,
  ListIcon,
  ListItem,
  Button,
  Link,
  Grid,
} from '@chakra-ui/react';
import Heading from '#coreComponents/Heading';
import { EventType, useTracking } from '#core/Tracking';

const Title = (props: HeadingProps) => (
  <Heading as="h2" lineHeight="10" {...props} />
);

const List = ({ items }: { items: string[] }) => (
  <ChakraList spacing={4}>
    {items.map((item, index) => (
      <ListItem key={`upsell-${index}`}>
        <Flex>
          <ListIcon as={CheckmarkFilled32} color="orange.400" boxSize="32px" />
          <Text fontSize="xl">{item}</Text>
        </Flex>
      </ListItem>
    ))}
  </ChakraList>
);

const Icon = ({
  component: Component,
}: {
  component: React.FC<CarbonIconProps>;
}) => (
  <Box justifySelf="center" data-testid="upsell-icon">
    <Component width={100} height={100} />
  </Box>
);

const UpsellScreen = ({ children, ...props }: BoxProps) => {
  const { trackEvent } = useTracking();
  const { pathname } = useLocation();

  const [, , productPath, pagePath] = pathname.split('/');

  useEffect(() => {
    trackEvent({
      type: EventType.PAGE_VIEW,
      payload: {
        id: `LEADGEN_${productPath}_${pagePath}`,
      },
    });
  }, [trackEvent, productPath, pagePath]);

  const onContact = () =>
    trackEvent({
      type: EventType.CLICK,
      payload: { id: 'upsell-contact-button', elementTagName: 'button' },
    });

  return (
    <Flex justifyContent="center" alignContent="center">
      <Box
        bg="white"
        px={{ base: 4, md: 8 }}
        py={8}
        boxShadow="base"
        borderRadius="md"
        maxWidth={1024}
        {...props}
      >
        <Grid rowGap={8}>
          {children}
          <Link
            href="mailto:data@timeshighereducation.com?subject=Datapoints Enquiry"
            justifySelf="center"
            isExternal
          >
            <Button onClick={onContact} colorScheme="yellow" variant="solid">
              Contact us
            </Button>
          </Link>
        </Grid>
      </Box>
    </Flex>
  );
};

UpsellScreen.Title = Title;
UpsellScreen.List = List;
UpsellScreen.Icon = Icon;

export default UpsellScreen;
